export default "__VITE_ASSET__C748oL9p__"